import React from 'react';
import { ChevronRight } from 'lucide-react';
import Sidebar from './Sidebar';
import { useApp } from '../../context/AppContext';
import { findMenuLocation } from './menuConfig';

const Layout = ({ children }) => {
  const { currentView } = useApp();
  const ubicacion = findMenuLocation(currentView);
  // Chats es una bandeja: usa toda la pantalla, con su propio encabezado y sin margenes.
  const pantallaCompleta = currentView === 'chats';

  return (
    <div className={`flex flex-col lg:flex-row bg-slate-100 ${pantallaCompleta ? 'h-screen' : 'min-h-screen'}`}>
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0 min-h-0">
        {/* Header */}
        <header className={`${pantallaCompleta ? 'hidden' : 'flex'} items-center justify-between px-4 lg:px-8 py-4 bg-white border-b border-slate-200`}>
          {ubicacion ? (
            <div className="flex items-center gap-1.5 text-[13px] text-slate-500">
              <span>{ubicacion.sectionLabel}</span>
              <ChevronRight size={14} className="text-slate-400" />
              <span className="text-slate-900 font-semibold">{ubicacion.itemLabel}</span>
            </div>
          ) : <div />}
        </header>
        {/* Contenido principal */}
        <main className={`flex-1 min-h-0 bg-slate-100 ${pantallaCompleta ? 'overflow-hidden' : 'p-4 lg:p-8 overflow-auto pt-4 lg:pt-8'}`}>
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
